import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import axiosInstance from '../axiosInstance';

const DueReceiptTable = () => {
    const [receipts, setReceipts] = useState([]);

    // useEffect(() => {
    //     // Inputs
    //     const no_of_dues = 4;
    //     let total = 7000;
    //     const emi_amount = 3280;
    //     let remainingDueBal = 52;
    //     let remainingPenalty = 1500;
    //     let remainingFine = 0;
    //     const due_day = 24;
    //     const finance_date = new Date('2025-04-04');
    //     const penalty_perday = 5;
    //     const today = new Date();

    //     const receiptsList = [];

    //     for (let i = 0; i < no_of_dues && total > 0; i++) {
    //         // Calculate due date (e.g., 24-06-2025)
    //         const baseDate = new Date(finance_date);
    //         baseDate.setMonth(baseDate.getMonth() + i + 1);
    //         let due_date;

    //         try {
    //             due_date = new Date(baseDate.getFullYear(), baseDate.getMonth(), due_day);
    //         } catch {
    //             due_date = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);
    //         }

    //         // Calculate def_days and fine
    //         const def_days = Math.max(Math.floor((today - due_date) / (1000 * 60 * 60 * 24)), 0);
    //         const calculated_fine = def_days * penalty_perday;

    //         let payedFine = 0;
    //         let fine_bal = 0;
    //         let payedPenalty = 0;
    //         let payedBal = 0;
    //         let dueReceived = 0;
    //         let remainingDue = emi_amount;

    //         // Deduct due balance first
    //         if (remainingDueBal > 0 && total > 0) {
    //             const used = Math.min(remainingDueBal, total);
    //             total -= used;
    //             remainingDueBal -= used;
    //             payedBal = used;
    //             remainingDue -= used;
    //         }

    //         // Deduct penalty next
    //         if (remainingPenalty > 0 && total > 0) {
    //             const used = Math.min(remainingPenalty, total);
    //             total -= used;
    //             remainingPenalty -= used;
    //             payedPenalty = used;
    //             remainingDue -= used;
    //         }

    //         // Deduct fine next
    //         let fineToUse = Math.min(calculated_fine, remainingFine);
    //         if (fineToUse > 0 && total > 0) {
    //             const used = Math.min(fineToUse, total);
    //             total -= used;
    //             payedFine = used;
    //             fine_bal = fineToUse - used;
    //             remainingFine -= used;
    //             remainingDue -= used;
    //         } else {
    //             fine_bal = fineToUse;
    //         }

    //         // Finally pay whatever remains toward due
    //         if (total > 0 && remainingDue > 0) {
    //             const used = Math.min(remainingDue, total);
    //             total -= used;
    //             dueReceived = used;
    //             remainingDue -= used;
    //         }

    //         receiptsList.push({
    //             due: i + 1,
    //             due_date: format(due_date, 'dd-MM-yyyy'),
    //             rcpt_no: 1,
    //             rcpt_date: format(today, 'dd-MM-yyyy'),
    //             due_amt: emi_amount,
    //             due_rcvd: dueReceived,
    //             due_bal: payedBal,
    //             def_days: def_days,
    //             fine: calculated_fine,
    //             payedFine: payedFine,
    //             fine_bal: fine_bal,
    //             penalty: 1500 - remainingPenalty,
    //             payedPenalty: payedPenalty,
    //         });
    //     }

    //     setReceipts(receiptsList);
    //     console.log("Data:", receiptsList)
    // }, []);


    useEffect(() => {
        // Inputs
        const no_of_dues = 2;
        let total = 7000;
        const emi_amount = 4933;
        let remainingDueBal = 0;
        let remainingPenalty = 0;
        let userProvidedFine = 0; // Fine amount provided by user
        const due_day = 24;
        const finance_date = new Date('2025-03-24');
        const penalty_perday = 5;
        const today = new Date();

        const receiptsList = [];

        // Step 1: Handle priority payments first (deduct from total)
        let totalDueBalPaid = 0;
        let totalPenaltyPaid = 0;
        let totalFinePaid = 0;

        // Pay outstanding due balance
        if (remainingDueBal > 0 && total > 0) {
            const used = Math.min(remainingDueBal, total);
            total -= used;
            totalDueBalPaid = used;
            remainingDueBal -= used;
        }

        // Pay penalty
        if (remainingPenalty > 0 && total > 0) {
            const used = Math.min(remainingPenalty, total);
            total -= used;
            totalPenaltyPaid = used;
            remainingPenalty -= used;
        }

        // Pay user provided fine
        if (userProvidedFine > 0 && total > 0) {
            const used = Math.min(userProvidedFine, total);
            total -= used;
            totalFinePaid = used;
            userProvidedFine -= used;
        }

        // Step 2: Now pay EMI dues in sequence
        let cumulativeFineBalance = 0; // Track cumulative fine balance

        for (let i = 0; i < no_of_dues; i++) {
            // Calculate due date
            const baseDate = new Date(finance_date);
            baseDate.setMonth(baseDate.getMonth() + i + 1);
            let due_date;

            try {
                due_date = new Date(baseDate.getFullYear(), baseDate.getMonth(), due_day);
            } catch {
                due_date = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);
            }

            // Calculate def_days and total fine due (for reference)
            const def_days = Math.max(Math.floor((today - due_date) / (1000 * 60 * 60 * 24)), 0);
            const total_fine_due = def_days * penalty_perday;

            // Add current row fine to cumulative fine balance
            cumulativeFineBalance += total_fine_due;

            // Pay current EMI due
            let dueReceived = 0;
            let dueBalance = emi_amount;

            if (total > 0) {
                const used = Math.min(emi_amount, total);
                total -= used;
                dueReceived = used;
                dueBalance = emi_amount - used;
            }

            // Allocate priority payments proportionally to first due (or as needed)
            let allocatedDueBal = 0;
            let allocatedPenalty = 0;
            let allocatedFine = 0;

            if (i === 0) {
                // Allocate all priority payments to first due for receipt
                allocatedDueBal = totalDueBalPaid;
                allocatedPenalty = totalPenaltyPaid;
                allocatedFine = totalFinePaid;
            }

            receiptsList.push({
                due: i + 1,
                due_date: format(due_date, 'dd-MM-yyyy'),
                rcpt_no: 1,
                rcpt_date: format(today, 'dd-MM-yyyy'),
                due_amt: emi_amount,
                due_rcvd: dueReceived,
                due_bal: dueBalance,
                due_balancepaid: allocatedDueBal, // Amount paid toward old due balance
                def_days: def_days,
                fine: total_fine_due,
                payedFine: allocatedFine,
                fine_bal: cumulativeFineBalance - totalFinePaid, // Cumulative fine balance
                penalty: i === 0 ? 1500 : 0, // Show penalty only in first row, then 0
                payedPenalty: allocatedPenalty, // Amount paid toward penalty
                penalty_bal: i === 0 ? remainingPenalty : 0,
                remaining_total: total // Show remaining total after this payment
            });

            // If no more money, break
            if (total <= 0) break;
        }

        setReceipts(receiptsList);
        console.log("Data:", receiptsList);
        console.log("Final remaining total:", total);
    }, []);


    // const calculateReceipts = () => {
    //     const no_of_dues = newRecord.noofdue;
    //     let total = newRecord.total;
    //     const emi_amount = newRecord.emi_amount;
    //     let remainingDueBal = newRecord.previous_due_balance;
    //     let remainingPenalty = newRecord.penalty;
    //     let userProvidedFine = newRecord.late_fine_paid;
    //     const due_day = parseInt(newRecord.due_day) || 1;
    //     const due_no = parseInt(newRecord.due_no) || 0;
    //     const finance_date = newRecord.finance_date;
    //     const next_date = newRecord.next_due_date;
    //     const penalty_perday = newRecord.penalty_perday;
    //     const today = new Date();
    //     const penalty = newRecord.penalty;

    //     const receiptsList = [];

    //     // Step 1: Handle priority payments first (deduct from total)
    //     let totalDueBalPaid = 0;
    //     let totalPenaltyPaid = 0;
    //     let totalFinePaid = 0;

    //     // Pay outstanding due balance
    //     if (remainingDueBal > 0 && total > 0) {
    //         const used = Math.min(remainingDueBal, total);
    //         total -= used;
    //         totalDueBalPaid = used;
    //         remainingDueBal -= used;
    //     }

    //     // Pay penalty
    //     if (remainingPenalty > 0 && total > 0) {
    //         const used = Math.min(remainingPenalty, total);
    //         total -= used;
    //         totalPenaltyPaid = used;
    //         remainingPenalty -= used;
    //     }

    //     // Pay user provided fine
    //     if (userProvidedFine > 0 && total > 0) {
    //         const used = Math.min(userProvidedFine, total);
    //         total -= used;
    //         totalFinePaid = used;
    //         userProvidedFine -= used;
    //     }

    //     // Step 2: Now pay EMI dues in sequence
    //     let totalFineAccumulated = 0; // Track total fine accumulated (not cumulative)
    //     let previousDueDate = null;

    //     for (let i = 0; i < no_of_dues; i++) {
    //         let due_date;

    //         if (i === 0) {
    //             // For first due: Check if next_date exists, otherwise use finance_date
    //             if (next_date && next_date.trim() !== '') {
    //                 due_date = new Date(next_date);
    //             } else {
    //                 const baseDate = new Date(finance_date);
    //                 baseDate.setMonth(baseDate.getMonth() + 1);
    //                 due_date = new Date(baseDate.getFullYear(), baseDate.getMonth(), due_day);

    //                 if (isNaN(due_date.getTime()) || due_date.getDate() !== due_day) {
    //                     due_date = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);
    //                 }
    //             }
    //         } else {
    //             // For subsequent dues: Add 1 month to previous due date
    //             due_date = new Date(previousDueDate);
    //             due_date.setMonth(due_date.getMonth() + 1);

    //             const originalDay = previousDueDate.getDate();
    //             if (isNaN(due_date.getTime()) || due_date.getDate() !== originalDay) {
    //                 due_date = new Date(due_date.getFullYear(), due_date.getMonth() + 1, 0);
    //             }
    //         }

    //         previousDueDate = new Date(due_date);

    //         // Calculate next due date
    //         const next_due_date = new Date(due_date);
    //         next_due_date.setMonth(next_due_date.getMonth() + 1);

    //         const currentDay = due_date.getDate();
    //         if (isNaN(next_due_date.getTime()) || next_due_date.getDate() !== currentDay) {
    //             next_due_date.setDate(0);
    //         }

    //         // Calculate def_days and current fine
    //         const def_days = Math.max(Math.floor((today - due_date) / (1000 * 60 * 60 * 24)), 0);
    //         const currentFine = def_days * penalty_perday;

    //         // Add current fine to total accumulated fine
    //         totalFineAccumulated += currentFine;

    //         // Pay current EMI due - USE REMAINING TOTAL, NOT FULL EMI
    //         let dueReceived = 0;
    //         let dueBalance = emi_amount;

    //         if (total > 0) {
    //             const used = Math.min(emi_amount, total);
    //             total -= used;
    //             dueReceived = used;
    //             dueBalance = emi_amount - used;
    //         }

    //         // Allocate priority payments to first due only
    //         let allocatedDueBal = 0;
    //         let allocatedPenalty = 0;
    //         let allocatedFine = 0;

    //         if (i === 0) {
    //             allocatedDueBal = totalDueBalPaid;
    //             allocatedPenalty = totalPenaltyPaid;
    //             allocatedFine = totalFinePaid;
    //         }

    //         // Helper function to format date as dd-MM-yyyy
    //         const formatDate = (date) => {
    //             const day = String(date.getDate()).padStart(2, '0');
    //             const month = String(date.getMonth() + 1).padStart(2, '0');
    //             const year = date.getFullYear();
    //             return `${day}-${month}-${year}`;
    //         };

    //         receiptsList.push({
    //             due_no: due_no + i + 1,
    //             due_date: formatDate(due_date),
    //             due_amt: emi_amount,
    //             due_rcvd: dueReceived,
    //             due_bal: dueBalance,
    //             fine_days: def_days,
    //             fine: currentFine,
    //             payed_fine: allocatedFine,
    //             balance_fine: totalFineAccumulated - totalFinePaid, // Total accumulated fine minus paid
    //             penalty: i === 0 ? penalty : 0,
    //             next_due_date: formatDate(next_due_date)
    //         });

    //         // If no more money, break
    //         if (total <= 0) break;
    //     }

    //     setReceipts(receiptsList);
    //     console.log("Data:", receiptsList);
    //     console.log("Final remaining total:", total);

    //     return receiptsList;
    // };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     if (validateForm()) {
    //         setErrors({});
    //         try {
    //             setLoading(true);

    //             // Calculate receipts and get the result immediately
    //             const calculatedReceipts = calculateReceipts();

    //             // Prepare data for API using the fresh calculated receipts
    //             const receiptData = {
    //                 finance_id: newRecord.id,
    //                 reg_no: newRecord.reg_no,
    //                 recipient_name: newRecord.recipient_name,
    //                 recipient_city: newRecord.recipient_city,
    //                 noofdue: newRecord.noofdue,
    //                 principal: newRecord.principal || 0,
    //                 interest: newRecord.interest || 0,
    //                 penalty: newRecord.penalty,
    //                 penalty_paid: calculatedReceipts.reduce((sum, r) => sum + (r.payedPenalty || 0), 0),
    //                 penalty_balance: calculatedReceipts.reduce((sum, r) => sum + (r.penalty_bal || 0), 0),
    //                 late_fine: calculatedReceipts.reduce((sum, r) => sum + (r.fine || 0), 0),
    //                 late_fine_paid: calculatedReceipts.reduce((sum, r) => sum + (r.payedFine || 0), 0),
    //                 late_fine_balance: calculatedReceipts.reduce((sum, r) => sum + (r.balance_fine || 0), 0),
    //                 previous_due_balance: newRecord.previous_due_balance,
    //                 due_amount: calculatedReceipts.reduce((sum, r) => sum + (r.due_amt || 0), 0),
    //                 due_amount_paid: calculatedReceipts.reduce((sum, r) => sum + (r.due_rcvd || 0), 0),
    //                 due_amount_balance: calculatedReceipts.reduce((sum, r) => sum + (r.due_bal || 0), 0),
    //                 total: newRecord.total,
    //                 payment_type: newRecord.payment_type,
    //                 remark: newRecord.remark,
    //                 created_by: newRecord.created_by,
    //                 modified_by: newRecord.created_by,
    //                 due_receipts: calculatedReceipts.map((receipt, index) => ({
    //                     due_no: receipt.due_no,
    //                     due_date: receipt.due_date, // Already formatted as dd-MM-yyyy
    //                     due_amt: receipt.due_amt,
    //                     due_rcvd: receipt.due_rcvd,
    //                     due_bal: receipt.due_bal,
    //                     fine_days: receipt.def_days,
    //                     penalty: receipt.penalty,
    //                     fine: receipt.fine,
    //                     payed_fine: receipt.payedFine,
    //                     balance_fine: receipt.balance_fine,
    //                     next_due_date: receipt.next_due_date // Already formatted as dd-MM-yyyy
    //                 }))
    //             };

    //             console.log("Receipt data:", receiptData);
    //             console.log("Due receipts:", receiptData.due_receipts);

    //             let response;
    //             response = await axios.post('https://apiemiride.socialpartners.in/api/receipt/add', receiptData);

    //             if (response.data.success) {
    //                 await Swal.fire('Created!', 'The Receipt has been Created.', 'success');
    //                 // Clear the newRecord state
    //                 setNewRecord({
    //                     id: "",
    //                     reg_no: "",
    //                     recipient_name: "",
    //                     recipient_city: "",
    //                     finance_date: "",
    //                     next_due_date: "",
    //                     loan_amount: "",
    //                     paid_loanamount: "",
    //                     balance_loanamount: "",
    //                     totaldue_count: "",
    //                     paiddue_count: "",
    //                     balancedue_count: "",
    //                     noofdue: "",
    //                     principal: "",
    //                     interest: "",
    //                     due_day: "",
    //                     due_no: "",
    //                     emi_amount: "",
    //                     previous_due_balance: "",
    //                     penalty_perday: "",
    //                     penalty: "",
    //                     penalty_paid: "",
    //                     penalty_balance: "",
    //                     late_fine: "",
    //                     late_fine_paid: "",
    //                     late_fine_balance: "",
    //                     due_amount: "",
    //                     due_amount_paid: "",
    //                     due_amount_balance: "",
    //                     total: "",
    //                     payment_type: "",
    //                     remark: "",
    //                 });

    //                 // Also clear receipts if needed
    //                 setReceipts([]);

    //                 // Navigate to finance page
    //                 navigate('/finance'); // or whatever your finance route is

    //             } else {
    //                 throw new Error(response.data.message);
    //             }

    //         } catch (error) {
    //             console.error('Error saving receipt:', error);
    //             const errorMessage = error.response?.data?.error || error.response?.data?.message || error.response?.statusText || 'An unknown error occurred';
    //             Swal.fire('Error!', `There was an issue creating the Receipt record: ${errorMessage}`, 'error');
    //         } finally {
    //             setLoading(false);
    //         }
    //     }
    // };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Receipt</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item"><a href="/finance">Finance</a></li>
                                <li className="breadcrumb-item active">Receipt</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ padding: '1rem', fontFamily: 'Arial' }}>
                <h2>Due Receipt Table</h2>
                <table border="1" cellPadding="10">
                    <thead>
                        <tr>
                            <th>Due</th>
                            <th>Due Date</th>
                            <th>Rcpt No</th>
                            <th>Rcpt Date</th>
                            <th>Due Amt</th>
                            <th>Due Rcvd</th>
                            <th>Due Bal</th>
                            <th>Previous Due Paid</th>
                            <th>Def Days</th>
                            <th>Fine</th>
                            <th>Payed Fine</th>
                            <th>Fine Bal</th>
                            <th>Penalty</th>
                            <th>Payed Penalty</th>
                        </tr>
                    </thead>
                    <tbody>
                        {receipts.map((r, i) => (
                            <tr key={i}>
                                <td>{r.due}</td>
                                <td>{r.due_date}</td>
                                <td>{r.rcpt_no}</td>
                                <td>{r.rcpt_date}</td>
                                <td>{r.due_amt}</td>
                                <td>{r.due_rcvd}</td>
                                <td>{r.due_bal}</td>
                                <td>{r.due_balancepaid}</td>
                                <td>{r.def_days}</td>
                                <td>{r.fine}</td>
                                <td>{r.payedFine}</td>
                                <td>{r.fine_bal}</td>
                                <td>{r.penalty}</td>
                                <td>{r.payedPenalty}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DueReceiptTable;
